import * as userActions from '../user/actions';
import * as lawsDeadlinesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const lawsDeadlinesReducer = (state = initialState, action) => {
    switch (action.type) {
        case lawsDeadlinesActions.SET_LAWS_DEADLINES_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching,
            };

        case lawsDeadlinesActions.SET_LAWS_DEADLINES_FETCHING_ERROR:
            return {
                list: null,
                isFetching: false,
                isLoaded: true,
                error: action.error,
            };

        case lawsDeadlinesActions.SET_LAWS_DEADLINES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case lawsDeadlinesActions.ABORT_DEADLINES_REQUEST:
            return initialState;

        case lawsDeadlinesActions.CLEAN_LAWS_DEADLINES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/lawsDeadlines/reducer.js